export default __webpack_public_path__ + "static/media/liveTraffic_Nay.dbecdf1b.svg";